import { FormControl, InputLabel, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { identity } from "lodash";

export const DatePickerInput = (props) => {
  const { description = "", label, value, onChange = identity } = props;

  const handleChange = (value) => {
    onChange({ target: { value: value.$d } });
  };

  return (
    <FormControl fullWidth>
      {/* {label ? <InputLabel>{label}</InputLabel> : null} */}
      <DemoContainer components={["DatePicker"]}>
        <DatePicker label={label} onChange={handleChange} value={value} />
      </DemoContainer>
      {description ? (
        <Typography variant="small" style={{ fontSize: "10px" }}>
          {description}
        </Typography>
      ) : null}
    </FormControl>
  );
};

export default DatePickerInput;
